import React from 'react';


const AboutPage = () => {
  return (
    <>
     
    </>
  );
};

export default AboutPage;
